export const getMeals = (state) => state.meals
export const getMealSaleElements = (state) => state.mealSaleElements
export const getMeal = (state) => (id) =>  state.meals.find(meal => meal.id == id)
export const getMealsByCategory = (state) => (id) => state.meals.filter(meal => meal.category_id === id) || []
